<template>
  <div>

    <CRow>
      <CCol lg="12">
        <h1 class="main-header" v-translate translate-context="event_owners">
          Event Owner List
        </h1>
        <CCard class="">
          <CCardHeader>
            <div class="card-header-actions">
              <router-link :to="{name: 'event_owner.new'}" v-if="hasPerm('event_owner.create')">
                <CButton block color="primary" v-translate translate-context="list.actions">Create</CButton>
              </router-link>
            </div>
          </CCardHeader>
          <CCardBody class="px-0">
            <CDataTable
                :hover="false"
                :bordered="true"
                :items="event_owners.results"
                :fields="fields"
                :column-filter="{external: true,lazy:true}"
                :column-filter-value="filters"
                :sorter="{external: true, resetable:true}"
                :loading="loading"
                :sorter-value="sorting"
                @update:column-filter-value="updateFilters"
                @update:sorter-value="updateSorting"
                class="custom-table custom-table--clean custom-table--has-filters"
            >
              <template #no-items-view>
                <div class="text-center">
                  <h5 v-translate>No items found</h5>
                </div>
              </template>
              <template #sorting-icon="{ state, classes }">
                <div :class="classes">
                  <CIcon name="cipCaretUp" size="lg" v-if="state === 'asc' || state === 0"></CIcon>
                  <CIcon name="cipCaretUp" size="lg" v-else></CIcon>
                </div>
              </template>
              <template #company_name="{item}">
                <td>
                  <CLink :to="{name: 'event_owner.detail', params: {id: item.id}}" style="color: #321fdb; font-weight: 500;">
                    {{ item.company_name }}
                  </CLink>
                </td>
              </template>
              <template #hide_events_on_pica="{item}">
                <td class="text-center">
                  <PBoolean :value="item.hide_events_on_pica"/>
                </td>
              </template>
              <template #hide_pica_events="{item}">
                <td class="text-center">
                  <PBoolean :value="item.hide_pica_events"/>
                </td>
              </template>
              <template #actions="{item}">
                <td class="text-right">
                  <CButton variant="outline" color="primary" size="sm" class="mr-1"
                           @click="$router.push({name: 'event_owner.edit', params: {id: item.id}})"
                           v-translate translate-context="list.actions"
                           v-if="hasPerm('event_owner.edit')"
                  >
                    Edit
                  </CButton>
                  <CButton @click="onDelete(item)" variant="outline" color="danger" size="sm"
                           v-translate translate-context="list.actions"
                           v-if="hasPerm('event_owner.delete')"
                  >
                    Delete
                  </CButton>
                </td>
              </template>
              <template #under-table>
                <CPagination
                    v-show="event_owners.pagination.num_pages > 1"
                    :activePage="event_owners.pagination.page"
                    @update:activePage="updatePage"
                    :pages="event_owners.pagination.num_pages"
                />
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>


    </CRow>

    <EventOwnerDeleteModal
      ref="deleteModal"
      @deleted="fetchList"
    />
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import EventOwnerDeleteModal from './components/EventOwnerDeleteModal'
import PBoolean from '@/domain/core/components/PBoolean.vue'

export default {
  name: 'ListEventOwner',

  components: {
    EventOwnerDeleteModal,
    PBoolean
  },

  data() {
    return {
      loading: true,
      fields: [
        {key: 'id', label: this.$pgettext('event_owners.list', 'ID'), _style: 'width:100px;'},
        {key: 'company_name', label: this.$pgettext('event_owners.list', 'Company Name')},
        {key: 'third_level_domain', label: this.$pgettext('event_owners.list', 'Domain')},
        {key: 'hide_events_on_pica', label: this.$pgettext('event_owners.list', 'Hide Events'), _style: 'width:120px;'},
        {key: 'hide_pica_events', label: this.$pgettext('event_owners.list', 'Hide Pica'), _style: 'width:120px;'},
        {key: 'actions', label: this.$pgettext('event_owners.list', 'Actions'), sorter: false, filter: false}
      ],
      pagination: {
        page_size: 20,
        page: 1,
      },
      sorting: {
        column: null,
        asc: false
      },
      filters: {},
    }
  },
  async mounted() {
    await Promise.all([
      this.fetchConfig({type: 'event_owner'}),
      this.fetchList()
    ])
  },
  computed: {
    ...mapGetters('eventOwner', [
      'event_owners',
    ]),
  },
  methods: {
    ...mapActions('eventOwner', [
      'fetchEventOwnerList',
      'deleteEventOwner'
    ]),
    ...mapActions('login', [
      'fetchConfig'
    ]),
    async fetchList() {
      this.loading = true
      await this.fetchEventOwnerList({
        filters: this.filters,
        pagination: this.pagination,
        sorting: this.sorting
      })
      this.pagination.page = this.event_owners.pagination.page
      this.loading = false
    },
    updateFilters(filters) {
      this.filters = filters
      this.pagination.page = 1
      this.fetchList()
    },
    updateSorting(sorting) {
      this.sorting = sorting
      this.fetchList()
    },
    updatePage(page) {
      this.pagination.page = page
      this.fetchList()
    },
    onDelete(item) {
      this.$refs.deleteModal.open(item)
    }
  }
}
</script>

<style scoped>

</style>
